import React from "react";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import {
  Grid,
  Table,
  TableHeaderRow,
} from "@devexpress/dx-react-grid-material-ui";

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word",
  },
};

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
);

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0,
    }}
    {...restProps}
  />
);

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class StatusTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Status LED" },
        { name: "descriptionColumn", title: "Beschreibung" },
      ],
      rows: [
        {
          actionColumn: "Rot blinkt langsam",
          descriptionColumn: "Normalbetrieb.",
        },
        {
          actionColumn: "Rot blinkt schnell",
          descriptionColumn: "Firmware-Update läuft.",
        },
        {
          actionColumn: "Rot ist deaktiviert",
          descriptionColumn:
            "LED ist über die WebUI deaktiviert wurden oder die Kamera hat keinen Strom.",
        },
        {
          actionColumn: "Bei aktiviertem HomeKit",
          descriptionColumn:
            "Verhalten (leuchtet/blinkt) gemäß Apple-Vorgaben. Wenn die Kamera in Apple Home eingebunden ist, steuert die Home-App die LEDs. Um sie dort auszuschalten, bitte in der Home-App deaktivieren.",
        },
        {
          actionColumn: "Blau dauerhaft aktiv",
          descriptionColumn:
            " WLAN verbunden / WPS-Bereitschaft (Reset 3 – 14 s).",
        },
        {
          actionColumn: "Blau blinkt langsam",
          descriptionColumn:
            "WPS aktiv (2 min) / Reset 15 – 19 s → WLAN & IP-Konfig. bleibt bestehen.",
        },
        {
          actionColumn: "Blau blinkt schnell",
          descriptionColumn:
            " WLAN unterbrochen / Reset 20 – 29 s → kompletter Werksreset.",
        },
        {
          actionColumn: "Blau ist deaktiviert",
          descriptionColumn:
            "LED aus, kein Strom oder LAN-Betrieb / Reset ≥ 30 s → alte Firmware-Partition.",
        },
        {
          actionColumn: "Bei aktiviertem HomeKit",
          descriptionColumn:
            "Verhalten (leuchtet/blinkt) gemäß Apple-Vorgaben. Wenn die Kamera in Apple Home eingebunden ist, steuert die Home-App die LEDs. Um sie dort auszuschalten, bitte in der Home-App deaktivieren.",
        },
      ],
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{ display: "inline-block", maxWidth: "915px" }}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

StatusTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StatusTable);
